
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc, collection, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { UserRole, UserProfile, Class } from '../types';

const firebaseConfig = {
  apiKey: "AIzaSyB7OZtq4FBSqy_N2qsmdLYHtCd-4dsgPlc",
  authDomain: "bsddigitaloortal.firebaseapp.com",
  projectId: "bsddigitaloortal",
  storageBucket: "bsddigitaloortal.firebasestorage.app",
  messagingSenderId: "818383210942",
  appId: "1:818383210942:web:ac2c51155ad9e6f86b91ef"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

const syncProfile = async (firebaseUser: any) => {
    const userRef = doc(db, 'users', firebaseUser.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        const profile: UserProfile = {
            uid: firebaseUser.uid,
            email: firebaseUser.email || '',
            displayName: firebaseUser.displayName || 'New User',
            role: UserRole.STUDENT, // Everyone starts as a student
            photoURL: firebaseUser.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(firebaseUser.displayName || 'User')}&background=random&color=fff`,
            createdAt: Date.now()
        };
        await setDoc(userRef, profile);
        return profile;
    }
    return userSnap.data() as UserProfile;
};

export const loginWithGoogle = async (): Promise<UserProfile> => {
    const result = await signInWithPopup(auth, googleProvider);
    return await syncProfile(result.user);
};

export const registerWithEmail = async (email: string, pass: string, name: string): Promise<UserProfile> => {
    // 1. Create the Auth account
    const result = await createUserWithEmailAndPassword(auth, email, pass);
    // 2. Update display name in Auth
    await updateProfile(result.user, { displayName: name });
    // 3. Create Firestore profile
    return await syncProfile(result.user);
};

export const loginWithEmail = async (email: string, pass: string): Promise<UserProfile> => {
    const result = await signInWithEmailAndPassword(auth, email, pass);
    return await syncProfile(result.user);
};

export const logoutUser = () => signOut(auth);

export const enrollInClassByCode = async (uid: string, code: string): Promise<string> => {
    const classesRef = collection(db, 'classes');
    const q = query(classesRef, where('code', '==', code.toUpperCase()));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
        throw new Error('Invalid class code. Please check and try again.');
    }

    const classDoc = querySnapshot.docs[0];
    const classData = classDoc.data() as Class;

    const userRef = doc(db, 'users', uid);
    await updateDoc(userRef, {
        classId: classDoc.id
    });

    return classData.name;
};
